import { useState, useEffect } from 'react';

/**
 * Хук для определения высоты виртуальной клавиатуры
 * Работает через отслеживание изменения высоты viewport
 */
export function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    // Инициализируем высоту viewport
    let initialViewportHeight = window.innerHeight;
    
    const handleResize = () => {
      const currentHeight = window.innerHeight;
      const heightDifference = initialViewportHeight - currentHeight;
      
      // Если высота уменьшилась более чем на 150px, считаем что появилась клавиатура
      // 150px - это примерный порог для определения появления клавиатуры
      if (heightDifference > 150) {
        setKeyboardHeight(heightDifference);
      } else {
        setKeyboardHeight(0);
      }
    };

    // Используем visualViewport API если доступен (более точный)
    if (window.visualViewport) {
      const handleVisualViewportChange = () => {
        const viewport = window.visualViewport;
        const heightDifference = window.innerHeight - viewport.height;
        
        if (heightDifference > 50) {
          setKeyboardHeight(heightDifference);
        } else {
          setKeyboardHeight(0);
        }
      };

      window.visualViewport.addEventListener('resize', handleVisualViewportChange);
      
      return () => {
        window.visualViewport.removeEventListener('resize', handleVisualViewportChange);
      };
    } else {
      // Fallback для браузеров без visualViewport API
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return keyboardHeight;
}
